export function getRandomColour() {
  return `hsla(${Math.floor(Math.random() * 255)}, ${30 + Math.floor(Math.random() * 70)}%, ${
    50 + Math.floor(Math.random() * 50)
  }%, 0.6)`;
}
